import React from 'react';
import { Button, message } from 'antd';
import { useNavigate } from 'react-router-dom';

const LogoutButton = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    // پاک کردن توکن یا اطلاعات کاربر از localStorage
    localStorage.removeItem('token');
    // می‌توان سایر اطلاعات کاربری را هم پاک کرد
    message.success('خروج با موفقیت انجام شد');
    // هدایت به صفحه ورود
    navigate('/');
  };

  return (
    <Button type="primary" danger onClick={handleLogout}>
      خروج
    </Button>
  );
};

export default LogoutButton;
